import { browserHttpLink } from '@seek/ca-graphql-client/src/http';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { metrics, setup as setupMetrics } from '@seek/metrics-js';

import App from 'src/components/App/App';
import type { ClientContext, SkuEnvironment } from 'src/types';
import config from 'src/config';
import { setupLogger } from 'src/modules/logger';
import { isMobileUserAgent } from 'src/modules/device-detect';
import { getCountryFromSite } from 'src/utils/melwaysUtils';

const pathnameToPageName = (pathname: string): string => {
  if (pathname.includes('my-activity/saved-searches')) {
    return 'saved-search';
  }
  if (pathname.includes('recommended')) {
    return 'recommended';
  }
  return '';
};

export default ({ site, environment, route, language }: ClientContext) => {
  const country = getCountryFromSite(site);
  const appConfig = config[country][environment as SkuEnvironment];
  const { metricsIsEnabled, metricsUrl } = appConfig;
  setupLogger({ environment, route });
  if (metricsIsEnabled) {
    setupMetrics({
      host: metricsUrl,
      isEnabled: metricsIsEnabled,
      prefix: `discover`,
      globalTags: [
        `country:${country}`,
        `environment:${environment}`,
        `route:${route}`,
        `device-type:${isMobileUserAgent() ? 'mobile' : 'desktop'}`,
        'service_name:disc-static-pages',
      ],
    });

    metrics.sendPagePerformance([
      `disc-static-pages:${pathnameToPageName(window.location.pathname)}`,
    ]);
  }

  hydrateRoot(
    document.getElementById('app')!,
    <App
      site={site}
      environment={environment}
      httpLink={browserHttpLink}
      route={route}
      language={language}
      {...appConfig}
    />,
  );
};
